import script from "./RestartAccountPasswordReset.vue?vue&type=script&lang=ts&setup=true"
export * from "./RestartAccountPasswordReset.vue?vue&type=script&lang=ts&setup=true"

import "./RestartAccountPasswordReset.vue?vue&type=style&index=0&id=43b64c7a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b64c7a"]])

export default __exports__